import { Controller } from 'stimulus'
import i18nSetup from "../i18n-setup"
import * as zxcvbn from 'zxcvbn'

export default class PasswordStrengthController extends Controller {
  static targets = [ 'password', 'strength', 'label' ]

  initialize() {
    this.i18n = i18nSetup()
  }

  connect() {
    this.labelTarget.textContent = this.i18n.t('web.javascript.password.strength.none')
  }

  show() {
    const password = this.passwordTarget.value || ''
    const value = zxcvbn(password).score
    $(this.strengthTarget).progress({
      autoSuccess: false,
      showActivity: false,
      label: '',
      total: 5,
      value: password === '' ? 0 : value + 1
    })
    if (password === '')
      this.labelTarget.textContent = this.i18n.t('web.javascript.password.strength.none')
    else
      this.labelTarget.textContent = this.strengthLabels()[value]
  }

  strengthLabels() {
    return [
      this.i18n.t('web.javascript.password.strength.trivial'),
      this.i18n.t('web.javascript.password.strength.too_weak'),
      this.i18n.t('web.javascript.password.strength.weak'),
      this.i18n.t('web.javascript.password.strength.strong'),
      this.i18n.t('web.javascript.password.strength.very_strong')
    ]
  }
}
